import React from "react";
import logo from "./logo.svg";
import { Counter } from "./features/counter/Counter";
import styled from "styled-components";
import "./App.css";
import Editor from "./pages/Editor/EditorComponent";
import WebfontLoader from "@dr-kobros/react-webfont-loader";

const SiteLayout = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
`;

// webfontloader configuration object. *REQUIRED*.
const config = {
  google: {
    families: ["Source Sans Pro:300,600", "Karla"],
  },
};

function App() {
  return (
    <SiteLayout>
      <WebfontLoader config={config}>
        <Editor />
      </WebfontLoader>
    </SiteLayout>
  );
}

export default App;
